import React, { useEffect, useState } from 'react'
import { Button } from 'antd'

import Styles from './apply-field-rule-tree.module.scss'
import { getUid } from '../../../../plugins/utils'
import { RelationTypeMap, RuleLogicMap } from '../../../../common/common'
import ApplyFieldRuleConditionRow from './ApplyFieldRuleConditionRow'

export const createEmptyConditionRow = (withRelation = false) => {
  const formData = {
    contentLogicType: RuleLogicMap.include,
    ruleName: '',
    fieldCode: '',
    fieldName: '',
    fieldType: '',
    fieldJoinSelect: '',
    selectContentName: undefined,
    selectContentItems: undefined
  }

  if (withRelation) {
    formData.ruleLogicType = RelationTypeMap.or
  }

  return {
    code: getUid(),
    formData,
    children: []
  }
}

export const createEmptySubRuleGroup = () => {
  return {
    code: getUid(),
    formData: {
      ruleLogicType: RelationTypeMap.or
    },
    children: [createEmptyConditionRow(false)]
  }
}

function ApplyFieldSubRuleGroup (props) {
  const [conditionList, setConditionList] = useState(props.subRuleGroup.children || [])

  useEffect(() => {
    setConditionList(props.subRuleGroup.children || [])
  }, [props.subRuleGroup])

  const syncChildren = (list) => {
    props.subRuleGroup.children = list
    setConditionList([...list])
    props.onChange?.()
  }

  const addConditionRow = (afterIndex) => {
    const list = [...(props.subRuleGroup.children || [])]
    const newRow = createEmptyConditionRow(list.length > 0)
    if (afterIndex == null || afterIndex >= list.length - 1) {
      list.push(newRow)
    } else {
      list.splice(afterIndex + 1, 0, newRow)
    }
    syncChildren(list)
  }

  const removeConditionRow = (rowCode) => {
    const list = (props.subRuleGroup.children || []).filter(item => item.code !== rowCode)
    if (!list.length) {
      list.push(createEmptyConditionRow(false))
    }
    syncChildren(list)
  }

  return (
    <div className={ Styles.subRuleGroupWrap }>
      {
        props.showGroupRelation && (
          <div className={ Styles.subRuleGroupConnector }>
            <span className={ Styles.subRuleGroupConnectorLabel }>或</span>
          </div>
        )
      }
      <div className={ Styles.subRuleGroup }>
        <div className={ Styles.subRuleGroupMain }>
          <div className={ Styles.subRuleGroupBody }>
            {
              conditionList.map((conditionItem, index) => {
                return (
                  <ApplyFieldRuleConditionRow
                    key={ conditionItem.code }
                    conditionItem={ conditionItem }
                    rowIndex={ index }
                    availableFields={ props.availableFields }
                    disabled={ props.disabled }
                    canRemove={ conditionList.length > 1 }
                    onAddRow={ () => addConditionRow(index) }
                    onRemoveRow={ () => removeConditionRow(conditionItem.code) }
                    onChange={ props.onChange }
                  ></ApplyFieldRuleConditionRow>
                )
              })
            }
          </div>
        </div>
        {
          !props.disabled && (
            <div className={ Styles.subRuleGroupAside }>
              <Button
                type="text"
                danger
                size="small"
                onClick={ props.onDeleteGroup }
              >删除</Button>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default ApplyFieldSubRuleGroup
